import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationSearchResults } from 'src/app/shared/models/notification';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../error/error.service';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsApiService extends ApiBaseService {
  baseUrl = environment.backend_host + '/api/notify';

  constructor(
    public http: HttpClient,
    public errorService: ErrorService,
    protected spinner: NgxSpinnerService) {
    super(spinner, errorService);
  }

  // notifications
  public getUserNotifications(): Observable<NotificationSearchResults> {
    return this.http.get<any>(`${this.baseUrl}/all`)
      .pipe(map(this.deserializeAs(NotificationSearchResults)))
  }

  public markNotificationAsRead = (id: number): Observable<any> => {
    return this.http.put<any>(`${this.baseUrl}/${id}`, {});
  }
}
